module.exports = __webpack_public_path__ + "img/digikala-alert.089e4f05.png";